/* istanbul ignore file */
import { useState } from 'react';
import usePurchaseOrderService, {
  LINK_INVOICE_TO_PURCHASE_ORDER,
  PURCHASE_ORDER_STATUSES,
} from 'domain/finance/purchaseOrder/usePurchaseOrderService';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import { useFieldHelper } from 'framework/ui/field';
import { FormFieldsData } from 'framework/form';
import PurchaseOrderDropdown from 'domain/finance/purchaseOrder/shared/input/PurchaseOrderDropdown';
import { useShowContext } from 'framework/show';

const LinkInvoiceToPurchaseOrderButton = ({
  statusSource,
  officeSource,
}: {
  statusSource: string;
  officeSource: string;
}) => {
  const { linkInvoiceToPurchaseOrder, invalidateCache } = usePurchaseOrderService();
  const { getValue } = useFieldHelper({ source: statusSource });
  const { getValue: getOffice } = useFieldHelper({ source: officeSource });
  const status = getValue();
  const office = getOffice();
  const [purchaseOrderIdErrors, setPurchaseOrderIdErrors] = useState<string[]>([]);
  const [purchaseOrderId, setPurchaseOrderId] = useState('');
  const { data: showData, setData = () => {} } = useShowContext();
  const invoiceId = showData.getValueBySource('id');

  if (status !== PURCHASE_ORDER_STATUSES.PENDING) {
    return null;
  }

  const onPurchaseOrderIdChange = (values: FormFieldsData) => {
    setPurchaseOrderId(values.purchaseOrderId);

    if (values.purchaseOrderId) {
      setPurchaseOrderIdErrors([]);
    } else {
      setPurchaseOrderIdErrors(['Field is required']);
    }
  };

  return (
    <ButtonWithConfirmation
      displayMessage=""
      modalChildren={
        <PurchaseOrderDropdown
          source="purchaseOrderId"
          officeData={office}
          value={purchaseOrderId as any}
          label="Please, choose purchase order"
          onChangeCallback={onPurchaseOrderIdChange}
          errorMessages={purchaseOrderIdErrors}
          isRequired
        />
      }
      submitMethod={() => linkInvoiceToPurchaseOrder(purchaseOrderId, invoiceId)}
      afterSubmit={{
        successMessage: 'The Invoice has been successfully linked to purchase order.',
        errorMessage: "Can't link this invoice to purchase order",
        execute: (data: any) => {
          invalidateCache();
          setData(data);
        },
      }}
      permissionToCheck={LINK_INVOICE_TO_PURCHASE_ORDER}
      variant="outlined"
      confirmBtnProps={{ disabled: !!purchaseOrderIdErrors.length || !purchaseOrderId }}
    >
      Link to purchase order
    </ButtonWithConfirmation>
  );
};

export default LinkInvoiceToPurchaseOrderButton;
